<template>
  <h1 class="ArticleHeading"><slot></slot></h1>
</template>

<style scoped>
.ArticleHeading {
  font-weight: 600;
  font-size: var(--font-size-11);
  line-height: 1.1;
  color: var(--text-color-black);
}
</style>
